import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'software-development',
    title: 'Software Development',
    description: 'Custom software solutions built with modern technologies to streamline your business processes and enhance productivity.',
    icon: 'CodeIcon',
  },
  {
    id: 'saas-solutions',
    title: 'SaaS Solutions',
    description: 'Scalable Software-as-a-Service platforms designed to grow with your business and provide seamless user experiences.',
    icon: 'CloudIcon',
  },
  {
    id: 'hardware-solutions',
    title: 'Hardware Solutions',
    description: 'Enterprise-grade hardware procurement, setup, and maintenance to ensure optimal performance and reliability.',
    icon: 'MonitorIcon',
  },
  {
    id: 'network-infrastructure',
    title: 'Network Infrastructure',
    description: 'Robust network design, implementation, and security solutions to keep your business connected and protected.',
    icon: 'NetworkIcon',
  },
  {
    id: 'it-consulting',
    title: 'IT Consulting',
    description: 'Strategic technology consulting to align your IT infrastructure with business objectives and drive digital transformation.',
    icon: 'ConsultingIcon',
  },
]; 